import { Grid } from 'src/design/atoms/Grid';
import React from 'react';
import { Header } from 'src/design/organisms/Header';
import { useJobs } from 'src/hooks/useJobs';
import { QuestionCard } from './QuestionCard';

export const Questions: React.FC = () => {
  const { selectedJob } = useJobs();

  if (!selectedJob) return null;

  return (
    <>
      <Header
        breadcrumbProps={{
          items: [
            { text: 'Jobs', href: '/jobs' },
            {
              text: `${selectedJob.name} - ${selectedJob.jobNumber}`,
              href: `/jobs/${selectedJob.id}/summary`,
            },
            { text: 'Daily Questions', href: '' },
          ],
        }}
        title="Daily Questions"
        helpText="Manage daily questions for this job."
      />
      <Grid>
        <Grid.Col span={6}>
          <QuestionCard jobId={selectedJob.id} />
        </Grid.Col>
      </Grid>
    </>
  );
};
